import { debounce } from 'lodash'
function setRem () {
  var width = document.documentElement.clientWidth
  var styleNode = document.createElement('style')
  styleNode.innerHTML = 'html{font-size:' + width / 10 + 'px !important}'
  document.head.appendChild(styleNode)
}
const docmHeight = document.body.clientHeight// 默认屏幕高度
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = debounce(function () {
  setRem()
}, 500)
